import { render, staticRenderFns } from "./CardTeams.vue?vue&type=template&id=7df13950&"
import script from "./CardTeams.vue?vue&type=script&lang=js&"
export * from "./CardTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports